// Invoice data for the invoice panel
const invoiceData = {
  options: [
    {
      id: 'issue_proforma_invoice',
      title: 'Issue Proforma Invoice',
      description: 'Create and issue a new proforma invoice for this delivery',
      icon: 'faFileInvoiceDollar',
      navigationPath: '/invoicing/proforma/create',
      side: 'sales'
    },
    {
      id: 'issue_final_invoice',
      title: 'Issue Final Invoice',
      description: 'Create and issue a tax-valid final invoice for this delivery',
      icon: 'faFileInvoice',
      navigationPath: '/invoicing/outgoing/create',
      side: 'sales'
    },
    {
      id: 'create_purchase_order',
      title: 'Create Purchase Order',
      description: 'Generate a purchase order from this delivery for supplier payment',
      icon: 'faFileContract',
      navigationPath: '/invoicing/purchase-orders/create',
      side: 'purchase'
    },
    {
      id: 'capture_incoming_invoice',
      title: 'Capture Incoming Invoice',
      description: 'Record the supplier invoice received for this delivery',
      icon: 'faFileImport',
      navigationPath: '/invoicing/incoming/create',
      side: 'purchase'
    },
    {
      id: 'issue_credit_note',
      title: 'Issue Credit Note',
      description: 'Reduce customer debt with a credit note for approved invoices',
      icon: 'faUndoAlt',
      navigationPath: '/invoicing/credit-notes/create',
      side: 'adjustment',
      color: '#ef4444'
    },
    {
      id: 'issue_debit_note',
      title: 'Issue Debit Note',
      description: 'Add additional charges to customer with a debit note',
      icon: 'faExclamationCircle',
      navigationPath: '/invoicing/debit-notes/create',
      side: 'adjustment',
      color: '#7c3aed'
    }
  ]
};

export default invoiceData; 